import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-daterange',
    templateUrl: 'daterange.component.html',
    styleUrls: ['./daterange.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DaterangeComponent implements OnInit {


  @Input() fromDate!: string;
  @Input() fromMin!: Date;
  @Input() fromMax!: Date;
  @Input() overlapError = false;
  @Input() overlapErrorMessage?: string;
  @Input() toDate!: string;
  @Input() toMin!: Date;
  @Input() toMax!: Date;
  @Input() readonly = false;
  @Input() touched = false;
  @Output() changed = new EventEmitter<{ from: string, to: string }>();
  @Input() width = '200px';
  errorMessages: string[] = [];
  valid = true;

  @Input() fromDateTooEarlyMessage?: string;
  @Input() toDateTooEarlyMessage?: string;
  @Input() fromDateTooLateMessage?: string;
  @Input() toDateTooLateMessage?: string;
  @Input() endDateTitle = 'End date';
  @Input() showLabel = true;
  @Input() placeholder!: string;

  ngOnInit() {
    this.validate();
  }

  validate() {

    this.errorMessages = [];

    if (!this.fromDate || !this.toDate) {
      return;
    }

    const from = new Date(this.fromDate);
    const to = new Date(this.toDate);
    if (from > to) {
      this.errorMessages.push('Invalid date range - end date must be after start date');
    }
    if (this.fromMin !== undefined && from < this.fromMin) {
      this.errorMessages.push(this.fromDateTooEarlyMessage || 'Start date is too early');
    }
    if (this.fromMax !== undefined && from > this.fromMax) {
      this.errorMessages.push(this.fromDateTooLateMessage || 'Start date is too late');
    }
    if (this.toMin !== undefined && to < this.toMin) {
      this.errorMessages.push(this.toDateTooEarlyMessage || 'End date is too early');
    }
    if (this.toMax !== undefined && to > this.toMax) {
      this.errorMessages.push(this.toDateTooLateMessage || 'End date is too late');
    }

    this.changed.emit({ from: this.fromDate, to: this.toDate });

    this.valid = !this.errorMessages.length;

  }



}
